export default __webpack_public_path__ + "static/media/catalyst.9433feb2.png";